import "./errors.scss";
import * as React from "react";
import { type IconProp } from "@fortawesome/fontawesome-svg-core";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";

type Props = {
    icon?: IconProp;
    title?: string | React.ReactNode;
    actions?: Array<React.ReactNode>;
    children: React.ReactNode;
};

export default class NiceError extends React.Component<Props> {
    public render(): React.ReactNode {
        let icon: IconProp = "meh";

        if(this.props.icon) {
            icon = this.props.icon;
        }

        let title: React.ReactNode = "Oh No!";

        if(this.props.title) {
            title = this.props.title;
        }

        if(typeof title === "string") {
            title = <h2>{title}</h2>;
        }

        let actions: Array<React.ReactNode> = [];

        if(this.props.actions) {
            actions = this.props.actions;
        }

        return (
            <div data-testid="nice-error" className="nice-error">
                <div className="nice-error-icon">
                    <FontAwesomeLight icon={icon} />
                </div>
                <div className="nice-error-reason">
                    <div className="nice-error-heading">
                        {title}
                    </div>
                    <div className="nice-error-body">
                        {this.props.children}
                    </div>
                    {actions.length !== 0 && (
                        <div className="nice-error-actions">
                            {actions.map((action, index) => (
                                <div className="nice-error-action" key={index}>
                                    {action}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
